import React from 'react'
// import './Destination.scss'

import data from '../../../data.json'
import { useState } from 'react'
import { useSetBodyBackgrounds } from '../../../shared/bodyBackgrounds'

const Destination = () => {
    const [destinations] = useState(data.destinations)
    const [currentIndex, setCurrentIndex] = useState(0)

    // Call Custom Hook to set Body Backgrounds
    useSetBodyBackgrounds('destination-bg')

    const {
        name,
        images: { png: image },
        description,
        distance,
        travel: travelTime,
    } = destinations[currentIndex]

    const destinationLinks = destinations.map((destination, index) => {
        return (
            <li key={destination.name} className='destination__nav-item'>
                <button
                    className='destination__nav-link'
                    onClick={() => setCurrentIndex(index)}
                >
                    {destination.name}
                </button>
            </li>
        )
    })

    return (
        <div className='container'>
            <div id='destId' className='destination maincontent'>
                <section className='destination__left'>
                    <h5 className='destination__choose-destination '>
                        <span>01</span>Pick your Destination
                    </h5>
                    <figure className='destination__planet-img-container'>
                        <img
                            className='destination__planet-img'
                            src={image}
                            alt={name}
                        />
                    </figure>
                </section>
                <section className='destination__right'>
                    <ul className='destination__nav-list'>
                        {destinationLinks}
                    </ul>
                    <h1 className='destination__planet-name'>{name}</h1>
                    <p className='destination__planet-description'>
                        {description}
                    </p>
                    <hr className='line' />
                    <section className='destination__info-section'>
                        <div className='destination__info-container'>
                            <h5 className='destination__subheading2'>
                                Avg. Distance
                            </h5>
                            <p className='destination__subheading1'>
                                {distance}
                            </p>
                        </div>
                        <div className='destination__info-container'>
                            <h5 className='destination__subheading2'>
                                Est. Travel Time
                            </h5>
                            <p className='destination__subheading1'>
                                {travelTime}
                            </p>
                        </div>
                    </section>
                </section>
            </div>
        </div>
    )
}

export default Destination
